import { render, staticRenderFns } from "./chat-message-image.vue?vue&type=template&id=6a152610&scoped=true"
import script from "./chat-message-image.vue?vue&type=script&lang=js"
export * from "./chat-message-image.vue?vue&type=script&lang=js"
import style0 from "./chat-message-image.vue?vue&type=style&index=0&id=6a152610&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a152610",
  null
  
)

export default component.exports